/* LocalTime.js */

"use strict";
const _ = require("lodash");

function localTime(timeInMilSeconds, defaultMsg = "Unknown") {
    let timestamp = new Date(timeInMilSeconds);

    let localDateTime = defaultMsg;
    if (_.isDate(timestamp)) {
        localDateTime = timestamp.toLocaleDateString() + " " + timestamp.toLocaleTimeString();
    }


    return(localDateTime);
}

module.exports = localTime;
